import { gql } from '@apollo/client';

const UPDATE_STUDY_PATIENT_MEDICAL_HISTORY = gql`
  mutation updateStudyPatientMedicalHistory($input: UpdateStudyPatientMedicalHistoryInput!) {
    updateStudyPatientMedicalHistory(input: $input) {
      isSuccess
      message
    }
  }
`;

export default UPDATE_STUDY_PATIENT_MEDICAL_HISTORY;
